module.exports = __webpack_public_path__ + "static/media/showmelove.aa25d520.svg";